<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/gUizL9/tc-custom/9781645753025.jpg?1719602420600" alt="This image is the cover for the book The First Culling"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The First Culling
      </h1>
      <p class="bookDescription body article font2">
        <p>A family moves into a southern Orange County neighborhood with a dark historic past. </p><p><br/></p><p>DEMONIC ACTS LEAVE DEMONIC TRACES. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michael Eicherly
      </h2>
      
      <p class="authorDescription body article"><p style='margin-top:0mm;margin-right:0mm;margin-bottom:0mm;margin-left:0mm;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'><span style='font-family:"Times New Roman",serif;'>Michael Eicherly was born in Garden Grove California, on January 10th, 1969. He currently lives in the Mission District of San Gabriel, California. Together, he and his wife have three children. His passions are horror films, music, books, family and Lucky Baldwin pubs.</span></p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?55c12bb9